import React, { Component } from 'react';
import "./style.scss";

import { Link } from "react-router-dom";

import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';

class TopNavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    }
  }

  toggle() {
    const { isOpen } = this.state;
    this.setState({
      isOpen: !isOpen
    })
  }

  render() {
    const { isOpen } = this.state;

    return (
      <div>
        <Navbar light expand="md" className="nav_container">
          <NavbarBrand href="/"><img className="nav_logo" src="https://res.cloudinary.com/djrdn2vgg/image/upload/v1589968854/SteamProject/steamlogo_fkkqkm.png" alt="logo" /></NavbarBrand>
          <NavbarToggler onClick={() => this.toggle()} />
          <Collapse isOpen={isOpen} navbar>
            <Nav className="mr-auto" navbar>
              <NavItem>
                <NavLink href="/">Magasin</NavLink>
              </NavItem>
              <NavItem>
                <NavLink>
                  <Link to="/list" className="link">
                    Jeux
                  </Link>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/">À propos</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/basket">
                  <Link to="/basket" className="link">
                    Panier
                  </Link>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/connexion">
                  <Link to="/connexion" className="link">
                    Connexion
                  </Link>
                </NavLink>
              </NavItem>
              { /*
              <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret>
                Options
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem>
                  Option 1
                </DropdownItem>
                <DropdownItem>
                  Option 2
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem>
                  Reset
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            */ }
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    );
  }
}

export default TopNavBar;